import View from "@pathwright/ui/src/components/ui/View"
import { WithCSS } from "@pathwright/ui/src/components/utils/styles"
import PropTypes from "prop-types"
import { css } from "styled-components"
import PathDivider from "./PathDivider"
import PathLesson from "./PathLesson"

const Path = ({ items, onEnterStep, inverted, expandedLessonsIds = [] }) => {
  return (
    <WithCSS
      as={View}
      className="LegacyPathView"
      css={css`
        position: relative;
        padding: 5px;
      `}
    >
      {items.map((item, index) => {
        const { id, type } = item
        if (type === "lesson") {
          return (
            <PathLesson
              key={id}
              lesson={item}
              onEnterStep={onEnterStep}
              initialExpand={
                expandedLessonsIds?.length > 0
                  ? expandedLessonsIds.includes(id)
                  : index === 0
              }
            />
          )
        } else if (type === "divider") {
          return <PathDivider key={id} divider={item} inverted={inverted} />
        } else {
          return null
        }
      })}
    </WithCSS>
  )
}

Path.displayName = "Path"

Path.defaultProps = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.number.isRequired
    })
  ).isRequired
}

export default Path
